import getTheme from "./getTheme";
export default function shadow(shadow, theme) {
    return getTheme(theme).shadow[shadow];
}
//# sourceMappingURL=shadow.js.map